import {
  css
} from 'lit';

export const LoadingSpinnerStyle = css`
.lds-loading-spinner {
  position: relative;
  display: inline-block;
}

.lds-loading-spinner-svg {
  animation: lds-loading-spinner infinite cubic-bezier(.25, .62, .74, .36);
}

.lds-loading-spinner-svg .grad-stop-1 {
  stop-color: var(--lds-color-loading-spinner-bg);
}

.lds-loading-spinner-svg .grad-stop-2 {
  stop-color: var(--lds-color-loading-spinner);
}

.lds-loading-spinner-svg-circle {
  fill: var(--lds-color-loading-spinner-bg);
}

.lds-loading-spinner-svg-cap {
  fill: var(--lds-color-loading-spinner);
}

@keyframes lds-loading-spinner {
  from { transform: rotate(0); }
  to { transform: rotate(360deg); }
}
`;

export default LoadingSpinnerStyle;
